import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-close\">\r\n    <path d=\"M14.95 16.82l8.31 8.27.91.91L26 24.18l-.91-.91L16.78 15 25 6.73l.91-.91L24.08 4l-.91.91-8.22 8.27L6.65 5l-.82-.91L4 5.91l.91.91L13.13 15l-8.22 8.27-.91.91L5.83 26l.91-.91z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol